import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CandidateJourneyStatusService } from './candidate-journey-status.service';
import { LocationQuery } from 'vue-router';
import { CandidateJourneyStatus } from './candidate-journey-status.interface';
const service = new CandidateJourneyStatusService();

export interface CandidateJourneyStatusState {
   candidateJourneyStatuses: Array<CandidateJourneyStatus>;
}

const CandidateJourneyStatusStore: Module<CandidateJourneyStatusState, StoreState> = {
   namespaced: true,
   state: {
      candidateJourneyStatuses: [],
   },
   getters: {},
   mutations: {
      SET_CANDIDATE_JOURNEY_STATUSES(state, candidateJourneyStatuses: Array<CandidateJourneyStatus>) {
         state.candidateJourneyStatuses = candidateJourneyStatuses;
      },
   },
   actions: {
      async getCandidateJourneyStatuses(context, query: LocationQuery) {
         const response = await service.getCandidateJourneyStatuses(query);
         context.commit('SET_CANDIDATE_JOURNEY_STATUSES', response.data);
         return response.data;
      },
   },
};

export default CandidateJourneyStatusStore;
